import { DSNCDealsSlider } from 'shared-definitions/types'
import { ApiComponentDealsMediumProps, ApiComponentDealsSliderProps } from 'data-source/types.wp'
import { dealsButtonMapper } from 'data-source/mappers/dealsButtonMapper'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'
import { optionalLinkMapper } from './optionalLinkMapper'

export function ncDealsSlider(
  input: ApiComponentDealsSliderProps | ApiComponentDealsMediumProps,
  opts: PLinkMapperOpts
): DSNCDealsSlider {
  return {
    resource: 'nc-deals-slider',
    items: input.deals.flatMap(item => {
      const image = imageMapper(item.image, opts)
      if (!image) {
        return []
      }
      return {
        buttons: [dealsButtonMapper(item, opts)],
        dataAttrs: item.data_attributes ?? {},
        pLinkRequestUpdate: null,
        pLinkEdit: optionalLinkMapper(item.edit_url),
        title: item.title,
        tags: [],
        image,
        anchor: null,
        msrp: null,
        textBadge: null,
      }
    }),
  }
}
